/*
  Helpers para cálculo de cuotas de un plan de pago en un dictado.

  Reglas de negocio definidas por cliente:
    - Cuotas iguales.
    - Cuotas consecutivas.
    - Se define la primera cuota al crear el dictado.
    - Las demás se calculan automáticamente (mes a mes).

  Ejemplo:
    12 cuotas desde 10/03/2024 → última cuota 10/02/2025.

  NOTA: mantener este archivo puro (sin dependencias de UI) para permitir
  reutilización en backend si llegara a moverse la lógica.
*/

export function calculateInstallmentDates(firstDueDate, count) {
  if (!firstDueDate || !count || count <= 0) return [];
  const base = new Date(firstDueDate);
  if (Number.isNaN(base.getTime())) return [];

  const dates = [];
  for (let i = 0; i < count; i += 1) {
    const d = new Date(base.getFullYear(), base.getMonth() + i, base.getDate());
    dates.push(d);
  }
  return dates;
}

export function calculateInstallmentAmount(totalAmount, count) {
  const total = Number(totalAmount);
  const n = Number(count);
  if (!total || !n || n <= 0) return 0;
  // Cuotas iguales. Se redondea a 2 decimales; si hay diferencia por
  // redondeo la primera cuota absorbe el residuo (decisión estándar).
  // Si el cliente prefiere lo contrario, cambiar en este único lugar.
  return Math.round((total / n) * 100) / 100;
}

/*
  Devuelve las cuotas ya armadas para un plan de pago dado:
    { index, dueDate: Date, amount: number }
  La primera cuota absorbe el residuo por redondeo.
*/
export function buildInstallments({ totalAmount, count, firstDueDate }) {
  const dates = calculateInstallmentDates(firstDueDate, count);
  const base = calculateInstallmentAmount(totalAmount, count);
  if (dates.length === 0) return [];

  const total = Number(totalAmount) || 0;
  const residual = Math.round((total - base * dates.length) * 100) / 100;

  return dates.map((dueDate, idx) => ({
    index: idx + 1,
    dueDate,
    amount: idx === 0 ? Math.round((base + residual) * 100) / 100 : base,
  }));
}

export function formatDateISO(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
